"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var __jsx = _react.default.createElement;
var CountryListing = function CountryListing(props) {
  var id = props.id,
    name = props.name;
  return __jsx(_react.default.Fragment, null, name && __jsx(_core.Link, {
    href: "#".concat(id)
  }, name));
};
var _default = CountryListing;
exports.default = _default;